<template>
  <div class="order_detail">
    <div class="order_detail_nav">
      <navbar
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        @goback="goBack(false)"
      />
    </div>
    <div class="box" :style="boxSty" v-if="detailInfo">
      <van-row class="status">
        <van-col span="24" class="tit">
          <img src="@/assets/purchaseSupplier/order/car.png" />
          <span v-if="detailInfo.status == 20 || detailInfo.status == 25"
            >待发货</span
          >
          <span v-if="detailInfo.status == 30">已发货</span>
        </van-col>
      </van-row>
      <div class="content">
        <van-row>
          <van-col
            span="24"
            class="show_address"
            v-if="detailInfo.delivery_address"
          >
            <p class="name">
              <img
                class="address"
                src="../../../assets/purchaseSupplier/common/address.png"
              />
              {{ detailInfo.delivery_address.consignee }}
              <span>{{ detailInfo.delivery_address.consignee_mobile }}</span>
              <img
                class="copy"
                src="../../../assets/purchaseSupplier/common/copy.png"
                @click="copyCode(1)"
              />
            </p>
            <p class="site" ref="copytxt1">
              {{
                detailInfo.delivery_address.address_name +
                detailInfo.delivery_address.address
              }}
            </p>
          </van-col>
        </van-row>
        <van-row class="goods_info_box" v-if="detailInfo.order_goods">
          <van-col span="24" class="title">商品信息</van-col>

          <van-col span="24" class="goods_info">
            <div
              class="info_box"
              v-for="(item, index) in detailInfo.order_goods"
              :key="index"
            >
              <div class="left">
                <img :src="item.sku_image" @error="nofind()" />
                <!-- <div class="goods_name">
                  {{ item.goods_name }}
                </div> -->
                <div class="wrapper-goods-name">
                  <input id="exp2"  class="exp"  type="checkbox">
                  <div class="text">
                    <label class="btn" for="exp2"></label>
                    {{ item.goods_name }}
                  </div>
                </div>
                <p class="spec">
                  <span v-if="item.specification_name">规格：</span
                  >{{ item.specification_name }}
                </p>
                <!-- <p>运费￥{{ item.goods_postage }}</p> -->
              </div>
              <div class="right">
                <p>￥{{ item.cost_price }}</p>
                <p>X{{ item.quantity }}</p>
              </div>
              <p class="goods_postage">运费￥{{ item.goods_postage }}</p>
            </div>
            <p class="money">
              合计金额：<span>￥{{ detailInfo.amount }}</span>
            </p>
          </van-col>
        </van-row>
        <van-row class="order_info">
          <van-col span="24" class="item">
            订单编号：
            <span ref="copytxt2">{{ detailInfo.ordersn }}</span>
            <img
              class="copy"
              src="../../../assets/purchaseSupplier/common/copy.png"
              @click="copyCode(2)"
            />
          </van-col>
          <van-col span="24" class="item">
            付款时间：{{ detailInfo.pay_time }}
          </van-col>
          <van-col span="24" class="item" v-if="detailInfo.status == 30">
            发货时间：{{ detailInfo.delivery_time }}
          </van-col>
          <van-col
            span="24"
            class="item item_wrap"
            v-if="detailInfo.buyer_remark"
          >
            买家备注：{{ detailInfo.buyer_remark }}
          </van-col>
        </van-row>
        <van-row
          class="supplier_info"
          v-if="
            detailInfo.supplier_remark ||
            (!detailInfo.supplier_remark && isSupplier == 1)
          "
        >
          <van-col
            span="24"
            class="item-noremark"
            v-if="detailInfo.supplier_remark"
          >
            <div>集采供应方备注：{{ detailInfo.supplier_remark }}</div>
            <a @click="showDialog2 = true" v-if="isSupplier == 1">撤销</a>
          </van-col>
          <van-col
            span="24"
            class="item"
            v-if="!detailInfo.supplier_remark && isSupplier == 1"
          >
            集采供应方备注：
            <div @click="showDialog1 = true" style="color: #999999">
              请输入你的备注
            </div>
          </van-col>
        </van-row>
        <van-row
          class="order_after_info"
          v-if="detailInfo.sale_data && detailInfo.sale_data.length != 0"
        >
          <van-col span="24" class="title item">售后信息</van-col>
          <van-col
            span="24"
            class="oder_after_phone"
            v-if="detailInfo.status == 30 || detailInfo.status == 20"
          >
            请及时与集采客服联系协商处理，避免影响订单操作
            <div>客服电话：<a href="tel:19906636087">19906636087</a></div>
          </van-col>
          <van-col span="24" class="item item_wrap">
            退款原因：{{ detailInfo.sale_data[0].reason }}
          </van-col>
          <van-col span="24" class="item">
            申请时间：{{ detailInfo.sale_data[0].created_at }}
          </van-col>
        </van-row>
      </div>
    </div>
    <van-row class="order_detail_footer">
      <van-col span="24" class="show_button">
        <btn
          :btntext="'联系买家'"
          :btnwidth="'16.5rem'"
          :height="'4.4rem'"
          :bgcolor="'#fff'"
          :borderradius="'2.2rem'"
          :btncolor="'#333'"
          :fontsize="'1.6rem'"
          :btnborder="'solid 0.05rem #eee'"
          @btnClick="contact"
        />
        <btn
          :btntext="'查看物流'"
          :btnwidth="'16.5rem'"
          :height="'4.4rem'"
          :bgcolor="'linear-gradient(to right, #fc740c, #f41a3c)'"
          :borderradius="'2.2rem'"
          :btncolor="'#fff'"
          :fontsize="'1.6rem'"
          @btnClick="logistics"
          :btnmargin="'0 0 0 1rem'"
          v-show="detailInfo.status == 30" />
        <btn
          :btntext="'立即发货'"
          :btnwidth="'16.5rem'"
          :height="'4.4rem'"
          :bgcolor="'linear-gradient(to right, #fc740c, #f41a3c)'"
          :borderradius="'2.2rem'"
          :btncolor="'#fff'"
          :fontsize="'1.6rem'"
          @btnClick="ship(item, '0')"
          :btnmargin="'0 0 0 1rem'"
          v-show="
            (detailInfo.status == 20 || detailInfo.status == 25) &&
            isSupplier == 1
          "
        />
      </van-col>
    </van-row>
    <div class="dialog2">
      <van-dialog
        v-model="showDialog2"
        message="确定撤销此条操作吗？"
        confirm-button-text="确认操作"
        confirm-button-color="#F9591B"
        cancel-button-text="取消"
        cancel-button-color="#999999"
        @confirm="changeRemark('0')"
        show-cancel-button
      >
      </van-dialog>
    </div>
    <div class="dialog2">
      <van-dialog
        v-model="showDialog1"
        confirm-button-text="确认"
        confirm-button-color="#F9591B"
        cancel-button-text="取消"
        cancel-button-color="#999999"
        @confirm="changeRemark('1')"
        @cancel="cancelRemark"
        :before-close="onBeforeClose"
        show-cancel-button
      >
        <div class="dialog_title">集采供应方备注：</div>
        <van-field
          type="textarea"
          v-model="supplierRemark"
          rows="3"
          maxlength="50"
          placeholder="请输入你的备注"
        />
      </van-dialog>
    </div>
  </div>
</template>
<script>
import navbar from "../components/nav-bar.vue";
import btn from "../components/button.vue";
import defaultImg from "@/assets/common/compare.png";
export default {
  components: {
    navbar,
    btn,
  },
  data() {
    return {
      lefticon: require("@/assets/accountAgent/my/reback.png"),
      detailInfo: {},
      boxSty: { padding: "10.4rem 1.6rem 6.5rem" },
      // storeId: "",
      isSupplier: "",
      supplierRemark: "",
      showDialog2: false,
      showDialog1: false
    };
  },
  created() {
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
    // this.storeId = this.$route.query.store_id;
    this.isSupplier = this.$route.query.is_supplier;
    this.getInfo();
  },
  mounted() {
    document
      .querySelector(".box")
      .addEventListener("scroll", this.handleScroll);
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );
    window.onresize = () => {
      document.documentElement.style.setProperty(
        "font-size",
        (document.body.clientWidth / 375) * 10 + "px"
      );
    };
  },
  methods: {
    goBack() {
      if (this.$route.query.isFrom) {
        this.params("", "", "goBack");
      } else {
        this.$router.go(-1);
      }
    },
    getInfo() {
      this.$api
        .post("/onorder/member/supplier/order/detail", {
          id: this.$route.query.isFrom
            ? this.$route.query.order_id
            : this.$route.query.id,
          supplier_member_id: this.$route.query.supplier_member_id,
        })
        .then((res) => {
          // res.delivery_address = JSON.parse(res.delivery_address);
          this.detailInfo = res;
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          //this.$toast(message);
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
          return;
        });
    },
    contact() {
      let parm = {
        id: this.detailInfo.member_id,
        name: this.detailInfo.user_name,
        store_id: this.detailInfo.shop_id,
        supplier_member_id: this.detailInfo.supplier_member_id,
      };
      this.params(JSON.stringify(parm), JSON.stringify(parm), "contact");
    },
    logistics() {
      localStorage.setItem(
        "delivery_address",
        JSON.stringify(this.detailInfo.delivery_address)
      );
      this.$router.push({
        path: "/purchaseSupplier/logisticsDetail",
        query: {
          com: this.detailInfo.order_logistics[0].post_code,
          nu: this.detailInfo.order_logistics[0].post_no,
          name: this.detailInfo.order_logistics[0].post_name,
          phone: this.detailInfo.delivery_address.consignee_mobile,
        },
      });
    },
    ship() {
      localStorage.setItem(
        "addressInfo",
        JSON.stringify(this.detailInfo.delivery_address)
      );
      this.$router.push({
        path: "/purchaseSupplier/ship",
        query: {
          orderid: this.detailInfo.id,
          goodsid: this.detailInfo.order_goods[0].goods_id,
          type: "0",
        },
      });
    },
    copyCode(index) {
      const rechage_range = document.createRange();
      if (index == 1) {
        rechage_range.selectNode(this.$refs.copytxt1);
      } else {
        rechage_range.selectNode(this.$refs.copytxt2);
      }
      const rechage_selection = window.getSelection();
      if (rechage_selection.rangeCount > 0) rechage_selection.removeAllRanges();
      rechage_selection.addRange(rechage_range);
      document.execCommand("Copy");
      this.$toast("复制成功");
      rechage_selection.removeAllRanges();
    },
    nofind() {
      var img = event.srcElement;
      img.src = defaultImg;
      img.onerror = null; //防止闪图
    },
    changeRemark(type) {
      if (type == "0") {
        this.supplierRemark = "";
      } else if (type == "1" && this.supplierRemark == "") {
        this.$toast("请输入你的备注");
        return false;
      }
      this.$api
        .post("onorder/member/order/modify-supplier-remarks", {
          order_id: this.$route.query.isFrom
            ? this.$route.query.order_id
            : this.$route.query.id,
          supplier_remark: type == "0" ? "" : this.supplierRemark,
        })
        .then((res) => {
          if (res) {
            this.getInfo();
            this.cancelRemark();
          }
        });
    },
    cancelRemark() {
      this.supplierRemark = "";
      this.showDialog1 = false;
    },
    onBeforeClose(action, done) {
      if (action === "confirm") {
        return done(false);
      } else {
        return done();
      }
    }
  },
};
</script>
<style>
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
</style>
<style lang="less" scoped>
.order_detail {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .order_detail_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    // background-color: #f5f6f7;
    z-index: 3;
  }

  .box {
    // padding: 10.4rem 1.6rem 6.5rem;
    box-sizing: border-box;
    height: 100%;
    background: url(../../../assets/purchaseSupplier/order/bg@2x.png) no-repeat
      center top;
    background-size: 100% 18rem;

    .status {
      color: #fff;
      font-size: 2rem;
      height: 2.8rem;
      text-align: center;
      margin-bottom: 1.3rem;
      font-weight: 700;

      .tit {
        line-height: 2.8rem;

        img {
          width: 2.4rem;
          margin-right: 0.8rem;
          vertical-align: middle;
        }
      }
    }

    ._status {
      height: 4.5rem;
      margin-bottom: 1.2rem;

      .tips {
        line-height: 1.7rem;
        font-size: 1.2rem;
        font-weight: 400;
      }
    }

    .after_reason {
      color: #333;
      font-size: 1.4rem;
      min-height: 8rem;
      padding: 1.6rem 1.2rem;
      background: #fff;
      border-radius: 0.8rem;
      margin-bottom: 1.2rem;
      text-align: left;
      box-sizing: border-box;

      .title {
        font-weight: 700;
        line-height: 2rem;
        margin-block: 0.8rem;
      }

      .tips {
        line-height: 2rem;
      }
    }

    .content {
      height: calc(100% - 4.1rem);
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;

      .show_address {
        min-height: 8.3rem;
        padding: 2.2rem 2.2rem 2rem 1.6rem;
        background: #fff;
        border-radius: 0.8rem;
        margin-bottom: 1.2rem;
        text-align: left;
        position: relative;
        box-sizing: border-box;

        .name {
          color: #333;
          font-size: 1.4rem;
          font-weight: 700;
          height: 2rem;
          line-height: 2rem;
          margin-bottom: 0.4rem;

          img {
            width: 2rem;
            vertical-align: middle;
          }

          .address {
            margin-right: 1.2rem;
          }

          .copy {
            float: right;
          }

          span {
            margin-left: 1.2rem;
          }
        }

        .site {
          color: #999;
          font-size: 1.2rem;
          line-height: 1.7rem;
          padding-left: 3.2rem;
        }
      }

      .goods_info_box {
        min-height: 17.4rem;
        border-radius: 0.8rem;
        background: #fff;
        padding: 1.6rem 1.2rem 2rem;
        color: #333;
        font-size: 1.4rem;
        box-sizing: border-box;
        margin-bottom: 1.2rem;

        .title {
          color: #333;
          font-size: 1.4rem;
          line-height: 2rem;
          font-weight: 700;
        }

        .goods_info {
          min-height: 11.8rem;
          font-size: 1.4rem;
          color: #333;
          padding-top: 1.6rem;
          box-sizing: border-box;

          .info_box {
            position: relative;

            .left {
              min-height: 70px;
              padding: 0 6.5rem 0 8rem;

              img {
                width: 7rem;
                height: 7rem;
                // float: left;
                position: absolute;
                top: 0;
                left: 0;
              }

              p {
                line-height: 2rem;
              }
              // .goods_name {
              //   // height: auto;
              //   display: -webkit-box; 
              //   -webkit-line-clamp: 2; 
              //   -webkit-box-orient: vertical; 
              //   overflow: hidden; 
              //   // height: 2rem;
              //   // white-space: nowrap;
              //   // overflow: hidden;
              //   // text-overflow: ellipsis;
              // }
              .wrapper-goods-name{
                display: inline-flex;
                overflow: hidden;
              /*   resize: horizontal; */
                .text {
                  font-size: 1.4rem;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  text-align: justify;
                  /* display: flex; */
                /*   display: -webkit-box;
                  -webkit-line-clamp: 3;
                  -webkit-box-orient: vertical; */
                  position: relative;
                  line-height: 1.5;
                  max-height: 3em;
                }
                .text::before {
                  content: '';
                  height: calc(100% - 2rem);
                  float: right;
                }
                .text::after {
                  content: '';
                  width: 999vw;
                  height: 999vw;
                  position: absolute;
                  box-shadow: inset calc(10rem - 999vw) calc(2.5rem - 999vw) 0 0 #fff;
                  margin-left: -10rem;
                }
                .btn{
                  position: relative;
                  float: right;
                  clear: both;
                  font-size: 1.2rem;
                  line-height: 2rem;
                  color:  #427CFA;
                  cursor: pointer;
                }
                .btn::after{
                  content:'展开';
                  background: url('../../../assets/purchaseSupplier/order/show_icon.png') no-repeat center right /1.6rem 1rem;
                  padding-right: 1.6rem;
                  margin-left: 2rem;
                }
                .exp{
                  display: none;
                }
                .exp:checked+.text{
                  max-height: none;
                }
                .exp:checked+.text::after{
                  visibility: hidden;
                }
                .exp:checked+.text .btn::before{
                  visibility: hidden;
                  display: none;
                }
                .exp:checked+.text .btn::after{
                  content:'收起';
                  background: url('../../../assets/purchaseSupplier/order/up_icon.png') no-repeat center right /1.6rem 1rem;
                  margin-left: 0;
                }
                .btn::before{
                  content: '...';
                  position: absolute;
                  // left: -0.4rem;
                  left: 1.2rem;
                  color: #333;
                  transform: translateX(-100%)
                }
              }
              .spec {
                color: #999;
                min-height: 2rem;
                margin: 0.4rem 0 0.6rem;
              }
            }

            .right {
              float: right;
              position: absolute;
              right: 0;
              top: 0;
              min-width: 6.5rem;
              text-align: right;

              p {
                margin-bottom: 0.4rem;
              }
            }

            .goods_postage {
              line-height: 2rem;
              text-align: right;
              font-size: 1.4rem;
              color: #999;
            }
          }

          .money {
            line-height: 2rem;
            text-align: right;
            margin-top: 0.4rem;

            span {
              color: #ff4747;
            }
          }
        }
      }

      .order_info {
        height: auto;
        border-radius: 0.8rem;
        background: #fff;
        padding: 1.4rem 1.2rem;
        color: #333;
        font-size: 1.4rem;
        box-sizing: border-box;
        margin-bottom: 1.2rem;
        .item {
          color: #333;
          line-height: 3.2rem;

          .copy {
            width: 2rem;
            vertical-align: middle;
            margin-left: 0.8rem;
          }
          a {
            color: #427cfa;
            margin-left: 0.3rem;
          }
        }
        .item-btn {
          width: 12rem;
          height: 3rem;
          line-height: 3rem;
          color: #fff;
          text-align: center;
          background: #ff4747;
          border-radius: 1rem;
        }
        .item_wrap {
          line-height: 2rem;
          // overflow: hidden;
          // text-overflow: ellipsis;
          // display: -webkit-box;
          // -webkit-line-clamp: 1;
          // -webkit-box-orient: vertical;
          // white-space: normal;
        }
      }

      .order_after_info {
        height: auto;
        border-radius: 0.8rem;
        background: #fff;
        padding: 1.4rem 1.2rem;
        color: #333;
        font-size: 1.4rem;
        box-sizing: border-box;
        .item {
          color: #333;
          line-height: 3.2rem;
        }
        .title {
          color: #333;
          font-size: 1.4rem;
          line-height: 3.2rem;
          font-weight: 700;
        }
        .oder_after_phone {
          color: #ff4747;
          padding: 0.5rem 0;
          font-size: 1.38rem;
          line-height: 2.2rem;
          a {
            color: #427cfa;
            text-decoration: underline;
            font-size: 1.4rem;
          }
        }
        .item_wrap {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          white-space: normal;
        }
      }
      .supplier_info {
        height: auto;
        border-radius: 0.8rem;
        background: #fff;
        padding: 1.4rem 0 1.4rem 1.2rem;
        color: #333;
        font-size: 1.4rem;
        box-sizing: border-box;
        margin-bottom: 1.2rem;
        .item {
          color: #333;
          line-height: 3.2rem;
          display: flex;
          align-items: center;
        }
        /deep/ .van-cell::after {
          display: none;
        }
        /deep/ .van-cell {
          padding: 0;
          flex: 1;
          padding: 0 0.5rem 0.1rem 0;
        }
        a {
          color: #427cfa;
          font-size: 1.4rem;
          padding: 0 1.2rem 0 0;
        }
        .item-noremark {
          color: #333;
          display: flex;
          // align-items: center;
          // line-height: 3.2rem;
          & > div {
            word-break: break-all;
            flex: 1;
            padding-right: 1rem;
            line-height: 2rem;
          }
        }
      }
    }
  }

  .order_detail_footer {
    height: 5.2rem;
    padding: 0.4rem 1.6rem 0;
    background: #fff;
    text-align: left;
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    .show_button {
      display: flex;
      justify-content: space-between;
    }
  }
}
.remark-box {
  background: #ffffff;
  width: 30rem;
  height: 16rem;
  padding: 2rem;
  border-radius: 5rem;
  text-align: center;
  font-size: 1.4rem;
}
.dialog2 {
  /deep/ .van-dialog__content--isolated {
    min-height: auto;
  }
  /deep/ .van-dialog__message {
    font-size: 1.4rem;
    padding: 3.2rem 6rem 3.4rem 6rem;
  }
  /deep/ .van-dialog {
    border-radius: 0.5rem;
  }
  /deep/ textarea {
    background: #f6f6f6;
    padding: 0.7rem;
    font-size: 1.2rem;
  }
  .dialog_title {
    padding: 2rem 1.5rem 0 1.5rem;
    font-size: 1.4rem;
    color: #333;
  }
}
</style>
<style lang="less" scoped>
.van-dialog {
  border-radius: 0;

  .van-dialog__confirm,
  .van-dialog__cancel {
    height: 5.2rem;
    font-size: 1.6rem;
  }

  .van-dialog__content--isolated {
    min-height: 6.2rem;

    .van-dialog__message {
      padding: 2.1rem 1rem;
      color: #333;
      font-weight: 700;
      font-size: 1.4rem;
    }
  }
}
</style>